import React from 'react';
import cx from 'classnames';
import { filterDataProps } from '@THC/utils/helpers';
import { resolveIconText } from './IconText.helpers';
import styles from './IconText.module.scss';
export const IconText = ({ alignIcon = 'left', icon: IconComponent, id, reverse = false, text, variant = 'xsmall--small', ...props }) => {
    const { iconSize, type } = resolveIconText(variant);
    return (<div {...filterDataProps(props)} className={cx(styles.iconText, styles[alignIcon], styles[`${iconSize}Icon`], styles[`${type}Type`], {
            [styles.reverse]: reverse,
        })} id={id}>
			<span className={styles.icon}>
				<IconComponent size={iconSize}/>
			</span>
			{text}
		</div>);
};
